import classNames from 'classnames'
import { useFormikContext } from 'formik'

import type { ReactElement } from 'react'
import type { IPageContainerFormValues } from '~/types/template'

import ProgressBar from '~/components/ProgressBar'
import { isPlaceholderFormValueCompleted } from '~/utils/page-container'

import './styles.scss'

const PageContainerCompletion = (): ReactElement => {
  const {
    values: { placeholders },
  } = useFormikContext<IPageContainerFormValues>()

  const totalPlaceholders = placeholders.length

  const completedPlaceholders = placeholders.filter((values) => isPlaceholderFormValueCompleted(values)).length

  const completionPercentage = (completedPlaceholders * 100) / totalPlaceholders

  const componentClasses = classNames('form-completion', { completed: completionPercentage === 100 })

  return (
    <div className={componentClasses}>
      <div className="form-completion__completion">
        <div className="form-completion__label">Completed: {`${completedPlaceholders} / ${totalPlaceholders}`}</div>
        <ProgressBar percentage={completionPercentage} />
      </div>
    </div>
  )
}

export default PageContainerCompletion
